export default __webpack_public_path__ + "static/grouping-do-7ec44ede7c54a20ecf95a0d3d3be927a4beb2b00f984919c47c58c00701b8e9a.png";